module.exports = __webpack_public_path__ + "img/side@2x.956a2230.png";